/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const ESC = 'Escape';
export const SPACE = ' ';
export const TAB = 'Tab';
export const UP = 'ArrowUp';
export const DOWN = 'ArrowDown';
export const RIGHT = 'ArrowRight';
export const LEFT = 'ArrowLeft';
export const HOME = 'Home';
export const END = 'End';
